/**
 * Create URL-friendly slug from dealer name
 */
export function createDealerSlug(dealerName: string): string {
  return dealerName
    .replace(/[^a-zA-Z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .toLowerCase(); // Convert to lowercase
}
